import {
    defaultBaseQuery,
    transformRequest,
    transformErrorResponse,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const leaveAllocationAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'leaveAllocationAPI',
    endpoints: (builder) => ({

        updateLeaveAllocation: builder.mutation({
            query: (data) => ({
                url: 'leave-balance/person',
                method: 'PUT',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getByIdLeaveAllocation: builder.query({
            query: (personId) => ({
                url: `/leave-balance/person?personId=${personId}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getListLeaveAllocation: builder.query({
            query: ({ departmentId, page = 0, size = 10, searchText = '', sortDir = 'asc' } = {}) => ({
                url: `/leave-balance`,
                method: 'GET',
                params: {
                    ...(departmentId && { encryptedDepartmentId: departmentId }),
                    page,
                    size,
                    ...(searchText && { searchText }),
                    ...(sortDir && { sortDir })
                }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        })
    })
});

export const { useLazyGetListLeaveAllocationQuery,
    useLazyGetByIdLeaveAllocationQuery, useUpdateLeaveAllocationMutation
} = leaveAllocationAPI;

export default leaveAllocationAPI;
